(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7597],{

/***/ 93871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 83047:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ielts-preparation-online/ielts-elite-demo/user-details-form",
      function () {
        return __webpack_require__(52291);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ liyValueProps; },
/* harmony export */   "BC": function() { return /* binding */ rewardPurchase; },
/* harmony export */   "QC": function() { return /* binding */ rewardsMapping; },
/* harmony export */   "Sl": function() { return /* binding */ rewardsListByDay; },
/* harmony export */   "We": function() { return /* binding */ demoFormRewardMweb; },
/* harmony export */   "Y$": function() { return /* binding */ ieltsFeatureList; },
/* harmony export */   "_z": function() { return /* binding */ demoFormReward; },
/* harmony export */   "iP": function() { return /* binding */ rewardFeatureList; },
/* harmony export */   "ts": function() { return /* binding */ rewardStatus; }
/* harmony export */ });
/* unused harmony exports ieltsBannerData, rewardCardFeatureList */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81964);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12615);




var ieltsBannerData = {
    title: "IELTS Plus Features",
    location: "Live Classes",
    established: "Mock Tests for all sections",
    season: "Personalised speaking evaluations",
    status: "Free Study Material",
    iconImages: {
        location: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/icons/liveClass.svg"),
        established: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/icons/mocks.svg"),
        season: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/icons/speaking.svg"),
        status: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/icons/public.svg")
    },
    imgSrc: {
        web: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/BannerImage-web.jpg"),
        mob: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/mobile-banner.png")
    }
};
var ieltsFeatureList = [
    {
        title: "Daily Live classes",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/feature/video.svg")
    },
    {
        title: "5 Mock Tests + Study Material",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/feature/book.svg")
    },
    {
        title: "3 Speaking & Writing Evalution",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/feature/writing.svg")
    }, 
];
var rewardFeatureList = [
    "Daily LIVE Classes",
    "1 Speaking Slot",
    "2 Mock Tests",
    "Study Materials", 
];
var rewardCardFeatureList = (/* unused pure expression or super */ null && ([
    "Daily Live Classes",
    "1 free speaking evaluation",
    "Study materials",
    "2 Mock Tests", 
]));
var rewardsListByDay = [
    {
        id: 1,
        label: "DAY 1",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/callRecording.svg"),
        data: "Unlimited, lifetime access to class recordings",
        title: "Class recordings",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_CLASS_RECORDINGS */ .CZ.IELTS_CLASS_RECORDINGS
    },
    {
        id: 2,
        label: "DAY 2",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/accesstospeakingrooms.svg"),
        data: "Download IELTS Prep App and start hosting your room speaking rooms for unlimited practice!",
        title: "Host access to speaking rooms",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    {
        id: 3,
        label: "DAY 3",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/fasttrack.svg"),
        data: "50 hours of crisp videos covering all major IELTS topics",
        title: "Fast Track course",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_STUDENT_DASHBOARD */ .CZ.IELTS_STUDENT_DASHBOARD
    },
    {
        id: 4,
        label: "DAY 4",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/speakingclubslots.svg"),
        data: "2 chances to practice and get feedback from a professional IELTS evaluator",
        title: "2 speaking club slots",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_SPEAKING_CLUB */ .CZ.IELTS_SPEAKING_CLUB
    },
    {
        id: 5,
        label: "DAY 5",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/doughtclass.svg"),
        data: "Attend extra classes conducted by your favourite teachers and clear all your doubts",
        title: "Extra doubt class",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    {
        id: 6,
        label: "DAY 6",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/speakingclubslots.svg"),
        data: "2 mock tests including a full length writing evaluation",
        title: "2 Mock tests",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_MOCK_TEST */ .CZ.IELTS_MOCK_TEST
    },
    {
        id: 7,
        label: "DAY 7",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/chatwithteacher.svg"),
        data: "Connect with Teacher on Telegram and clear your doubts!",
        title: "Chat with Educator",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    {
        id: 8,
        label: "DAY 8",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/discounticon.svg"),
        data: "Unlock a discount on IELTS Premium - our flagship course with just 20 students in a batch, extra mock tests, and personal evaluations for speaking and writing!",
        title: "10% off on IELTS Premium",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_ALL_BATCHES */ .CZ.IELTS_ALL_BATCHES
    },
    {
        id: 9,
        label: "DAY 9",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/speakingclubslots.svg"),
        data: "1 mock tests including a full length writing evaluation",
        title: "1 Mock test",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_MOCK_TEST */ .CZ.IELTS_MOCK_TEST
    },
    {
        id: 10,
        label: "DAY 10",
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/speakingclubslots.svg"),
        data: "2 chances to practice and get feedback from a professional IELTS evaluator",
        title: "5 speaking club slots",
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_SPEAKING_CLUB */ .CZ.IELTS_SPEAKING_CLUB
    }, 
];
var rewardsMapping = {
    SPEAKING_ROOM_HOST: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/accesstospeakingrooms.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    RECORDING: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/callRecording.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_CLASS_RECORDINGS */ .CZ.IELTS_CLASS_RECORDINGS
    },
    FAST_TRACK_COURSE: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/fasttrack.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.FAST_TRACK */ .CZ.FAST_TRACK
    },
    SPEAKING_CLUB_SLOT: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/accesstospeakingrooms.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    EXTRA_DOUBT_CLASS: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/doughtclass.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    MOCK_TEST: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/speakingclubslots.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_MOCK_TEST */ .CZ.IELTS_MOCK_TEST
    },
    TEACHER_CHAT: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/chatwithteacher.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_REWARDS */ .CZ.IELTS_REWARDS
    },
    DISCOUNT: {
        img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/rewardicons/discounticon.svg"),
        url: page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.IELTS_ALL_BATCHES */ .CZ.IELTS_ALL_BATCHES
    }
};
var rewardPurchase = {
    FREE_COURSE_PURCHASE: "FREE_COURSE_PURCHASE",
    DEFAULT_PURCHASE: "DEFAULT_PURCHASE"
};
var rewardStatus = {
    LOCKED: "LOCKED",
    ACTIVE: "ACTIVE",
    UNLOCKED: "UNLOCKED"
};
var demoFormReward = [
    {
        id: 1,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Learn IELTS exam ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "desktop"
                }),
                " and structure"
            ]
        }),
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts-demo/offers/lecture.svg")
    },
    {
        id: 2,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Get your Band ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "desktop"
                }),
                " predicted"
            ]
        }),
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts-demo/offers/class.svg")
    },
    {
        id: 3,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Tips and tricks to ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "desktop"
                }),
                " improve your band"
            ]
        }),
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts-demo/offers/group.svg")
    }, 
];
var demoFormRewardMweb = [
    {
        id: 1,
        title: "Live interaction with IELTS mentor",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/live_icon_youtube.svg")
    }, 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(demoFormReward));
var liyValueProps = [
    "Unlocking 1-on-1 Speaking Evaluations",
    "Finding Writing Feedback",
    "Adding recorded lecture videos",
    "Looking for Mock Tests to practice", 
];


/***/ }),

/***/ 18459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Inputs_CustomInputSelectV5; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(66089);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
;// CONCATENATED MODULE: ./components/Inputs/CustomInputSelectionCheckboxV8.tsx




var CustomInputSelectionCheckboxV8 = function(param) {
    var label = param.label, input = param.input, icon = param.icon, remainder = param.remainder, onClick = param.onClick, color = param.color, ieltsQe = param.ieltsQe;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-725ac5e12b4775f0" + " " + "flex justify-start items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "jsx-725ac5e12b4775f0" + " " + " w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "jsx-725ac5e12b4775f0" + " " + "checkbox-label my-2 w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                type: "checkbox"
                            }, input), {
                                onClick: onClick,
                                className: "jsx-725ac5e12b4775f0" + " " + (input && input.className != null && input.className || " w-full ")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-725ac5e12b4775f0" + " " + "checkbox-custom rectangular"
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-725ac5e12b4775f0" + " " + "bg-white  border text-font14 text-center md:px-4 px-3 bold input-reaction cursor-pointer w-full md:w-[498px] grid-layout min-h-fit ".concat(ieltsQe ? "shadow-[0px_4px_8px_rgba(67,54,149,0.08)] rounded-lg m-auto" : "gap-y-3 rounded", " py-4 justify-between md:flex md:gap-x-4 md:justify-around"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-725ac5e12b4775f0" + " " + "flex grid-area-a",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "jsx-725ac5e12b4775f0" + " " + "".concat(typeof icon == "string" ? "" : "md:py-0 py-0 my-auto mx-0", " leading-none md:w-auto text-black text-center text-font16"),
                                            children: label
                                        })
                                    }),
                                    remainder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: color ? {
                                            borderColor: color,
                                            color: color
                                        } : {},
                                        className: "jsx-725ac5e12b4775f0" + " " + "rounded-22 border px-3 text-[11px] md:text-[12px] grid-area-b",
                                        children: remainder
                                    }),
                                    !icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-725ac5e12b4775f0" + " " + "flex justify-end flex-grow-[2] grid-area-c",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/v8/blueArrow.svg"),
                                            width: "14",
                                            height: "14",
                                            alt: "logo",
                                            className: "jsx-725ac5e12b4775f0" + " " + ""
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "725ac5e12b4775f0",
                    children: 'checkbox-container.jsx-725ac5e12b4775f0{float:left;width:50%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center;padding:90px 0px;border:1px solid red}.grid-layout.jsx-725ac5e12b4775f0{display:grid;grid-template-areas:"a c""b c"}.grid-area-a.jsx-725ac5e12b4775f0{grid-area:a}.grid-area-b.jsx-725ac5e12b4775f0{grid-area:b}.grid-area-c.jsx-725ac5e12b4775f0{grid-area:c}.checkbox-label.jsx-725ac5e12b4775f0{display:block;position:relative;cursor:pointer;font-size:22px;line-height:24px;clear:both}.checkbox-label.jsx-725ac5e12b4775f0 input.jsx-725ac5e12b4775f0{position:absolute;opacity:0;cursor:pointer}.checkbox-label.jsx-725ac5e12b4775f0 .input-reaction.jsx-725ac5e12b4775f0{border:1px solid#d6d5e5}.checkbox-label.jsx-725ac5e12b4775f0 input.jsx-725ac5e12b4775f0:checked~.input-reaction.jsx-725ac5e12b4775f0{background-color:#e3e4ff;border:2px solid#494fe3}.flag-img.jsx-725ac5e12b4775f0{height:24px;width:36.63px;margin:0 auto}@media only screen and (max-device-width:768px){.input-with-icon.jsx-725ac5e12b4775f0{width:300px;height:72px;padding:10px 0px}}@media only screen and (min-device-width:769px){.input-with-icon.jsx-725ac5e12b4775f0{width:350px;height:100px;padding:16px 0px}.grid-layout.jsx-725ac5e12b4775f0{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}}@media only screen and (max-device-width:768px){.input-without-icon.jsx-725ac5e12b4775f0{width:300px;min-height:48px}}@media only screen and (min-device-width:769px){.input-without-icon.jsx-725ac5e12b4775f0{width:498px;height:52px}}'
                })
            ]
        })
    });
};
/* harmony default export */ var Inputs_CustomInputSelectionCheckboxV8 = (CustomInputSelectionCheckboxV8);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./uiKit/utils/withWindowDimensions.tsx
var withWindowDimensions = __webpack_require__(96683);
;// CONCATENATED MODULE: ./components/Inputs/CustomInputSelectionCheckboxV4.tsx




var CustomInputSelectionCheckboxV4 = function(param) {
    var label = param.label, input = param.input, icon = param.icon, remainder = param.remainder, onClick = param.onClick, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-74a07e84ca49070c" + " " + "flex justify-start items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "jsx-74a07e84ca49070c" + " " + " w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "jsx-74a07e84ca49070c" + " " + "checkbox-label my-2 w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                type: "checkbox"
                            }, input), {
                                onClick: onClick,
                                className: "jsx-74a07e84ca49070c" + " " + (input && input.className != null && input.className || " w-full")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-74a07e84ca49070c" + " " + "checkbox-custom rectangular"
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-74a07e84ca49070c" + " " + "bg-white rounded border text-font14 text-center md:pr-4 md:pl-4 px-2 justify-between  flex items-center bold input-reaction cursor-pointer h-51 w-full md:w-[498px]}",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-74a07e84ca49070c" + " " + "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "jsx-74a07e84ca49070c" + " " + "".concat(typeof icon == "string" ? "" : "md:py-0 py-0 my-auto mx-0", " leading-none md:w-auto text-black text-center text-font16"),
                                                children: label
                                            }),
                                            remainder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: color ? {
                                                    borderColor: color,
                                                    color: color
                                                } : {},
                                                className: "jsx-74a07e84ca49070c" + " " + " rounded-22 border px-3 ml-4 text-font10 font-semibold ",
                                                children: remainder
                                            })
                                        ]
                                    }),
                                    !icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/v8/blueArrow.svg"),
                                        alt: "logo",
                                        className: "jsx-74a07e84ca49070c" + " " + ""
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "74a07e84ca49070c",
                    children: "checkbox-container.jsx-74a07e84ca49070c{float:left;width:50%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center;padding:90px 0px;border:1px solid red}.checkbox-label.jsx-74a07e84ca49070c{display:block;position:relative;cursor:pointer;font-size:22px;line-height:24px;clear:both}.checkbox-label.jsx-74a07e84ca49070c input.jsx-74a07e84ca49070c{position:absolute;opacity:0;cursor:pointer}.checkbox-label.jsx-74a07e84ca49070c .input-reaction.jsx-74a07e84ca49070c{border:1px solid#d6d5e5}.checkbox-label.jsx-74a07e84ca49070c input.jsx-74a07e84ca49070c:checked~.input-reaction.jsx-74a07e84ca49070c{background-color:#e3e4ff;border:2px solid#494fe3}.flag-img.jsx-74a07e84ca49070c{height:24px;width:36.63px;margin:0 auto}@media only screen and (max-device-width:768px){.input-with-icon.jsx-74a07e84ca49070c{width:300px;height:72px;padding:10px 0px}}@media only screen and (min-device-width:769px){.input-with-icon.jsx-74a07e84ca49070c{width:350px;height:100px;padding:16px 0px}}@media only screen and (max-device-width:768px){.input-without-icon.jsx-74a07e84ca49070c{width:300px;min-height:48px}}@media only screen and (min-device-width:769px){.input-without-icon.jsx-74a07e84ca49070c{width:498px;height:52px}}"
                })
            ]
        })
    });
};
/* harmony default export */ var Inputs_CustomInputSelectionCheckboxV4 = (CustomInputSelectionCheckboxV4);

;// CONCATENATED MODULE: ./components/Inputs/CustomInputSelectV5.tsx






var CustomInputSelectV5 = function(param) {
    var input = param.input, options = param.options, meta = param.meta, isMultiSelect = param.isMultiSelect, subText = param.subText, numGridColumns = param.numGridColumns, onClick = param.onClick, setValue = param.setValue, isMobileSized = param.isMobileSized, _checkBoxVersion = param.checkBoxVersion, checkBoxVersion = _checkBoxVersion === void 0 ? null : _checkBoxVersion, ieltsQe = param.ieltsQe;
    var gridColCssStr = (0,react.useMemo)(function() {
        return "grid-cols-2";
    }, [
        numGridColumns
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lightgray-800 text-font14 md:text-base",
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(gridColCssStr, "  "),
                children: options.map(function(option, i) {
                    var label = option.label, value = option.value, icon = option.icon, remainder = option.remainder, color = option.color;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: input.name,
                            component: checkBoxVersion === 8 ? Inputs_CustomInputSelectionCheckboxV8 : Inputs_CustomInputSelectionCheckboxV4,
                            type: isMultiSelect ? "checkbox" : "radio",
                            value: value,
                            label: label,
                            icon: icon,
                            color: color,
                            isMobileSized: isMobileSized,
                            remainder: remainder,
                            optionSize: options.length,
                            onClick: onClick,
                            setValue: setValue,
                            ieltsQe: ieltsQe
                        })
                    }, i);
                })
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-1 text-xs text-red-600 md:pl-2 pl-4",
                children: meta.error
            })
        ]
    });
};
/* harmony default export */ var Inputs_CustomInputSelectV5 = ((0,withWindowDimensions/* default */.Z)(CustomInputSelectV5));


/***/ }),

/***/ 46584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66089);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useDevice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84367);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83697);







var TextInput = function(param) {
    var input = param.input, meta = param.meta, label = param.label, disabled = param.disabled, placeholder = param.placeholder, helperText = param.helperText, icon = param.icon, isNewOnboardingExp = param.isNewOnboardingExp, min = param.min, max = param.max, _isWc = param.isWc, isWc = _isWc === void 0 ? false : _isWc, onFocus = param.onFocus, onBlur = param.onBlur, _inputCss = param.inputCss, inputCss = _inputCss === void 0 ? "" : _inputCss, _isSignNeeded = param.isSignNeeded, isSignNeeded = _isSignNeeded === void 0 ? false : _isSignNeeded, formId = param.formId;
    var isIos = (0,hooks_useDevice__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isIos;
    var hasError = meta && meta.touched && meta.error;
    var value = input && input.value !== "";
    var name = input && input.name;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (0,scripts_segment__WEBPACK_IMPORTED_MODULE_4__.trackPage)(input === null || input === void 0 ? void 0 : input.name, {
            formId: formId
        });
    }, []);
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            event.preventDefault() // Prevent default behavior (like form submission)
            ;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-d6214775e28d7de4" + " " + "relative w-full ".concat(isNewOnboardingExp ? "px-6" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-d6214775e28d7de4" + " " + ((value && !isNewOnboardingExp && !isWc ? "is-filled !w-full" : "") || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        id: "field-".concat(name),
                        placeholder: placeholder ? placeholder : label,
                        disabled: disabled,
                        min: min || "",
                        max: max || ""
                    }, input), {
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onKeyDown: handleKeyDown,
                        className: "jsx-d6214775e28d7de4" + " " + (input && input.className != null && input.className || "h-12 relative px-4 w-full border ".concat(isWc ? "border" : "border-2", " bg-white ").concat(isNewOnboardingExp ? " focus:!border-[#BBAAEC] bg-transparent border-2 border-[#BBAAEC] placeholder:!text-[#686868] !text-white" : "pt-1", " ").concat(isWc && "placeholder:!text-[#A5A4B6]", " rounded-lg text-base leading-tight ").concat(hasError ? "border-red-600" : "border-[#CDCDCD]", " ").concat(inputCss))
                    })),
                    isSignNeeded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-d6214775e28d7de4" + " " + " absolute slide-up top-[50%] translate-y-[-50%] right-16  text-[#8E8E8E]",
                        children: "%"
                    }),
                    isIos && !(input === null || input === void 0 ? void 0 : input.value) && (input === null || input === void 0 ? void 0 : input.type) === "date" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "jsx-d6214775e28d7de4" + " " + " absolute top-[50%] pl-4 text-[#686868]",
                        children: placeholder
                    }),
                    !isNewOnboardingExp && !isWc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "field-".concat(name),
                        className: "jsx-d6214775e28d7de4" + " " + "inputLabel absolute text-xxs inline-block px-4 ".concat(isNewOnboardingExp ? "text-white left-[24px]" : "text-black left-0 ", " opacity-0 cursor-auto top-0 mt-1 md:mt-2"),
                        children: label
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-d6214775e28d7de4" + " " + "absolute top-0 right-0 mr-4 mt-4",
                children: icon
            }),
            helperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "jsx-d6214775e28d7de4" + " " + "text-sm text-lightgray-400 leading-tight mt-2",
                children: helperText
            }),
            hasError && !meta.active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "jsx-d6214775e28d7de4" + " " + "mt-1 text-xs text-red-600",
                children: meta.error
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d6214775e28d7de4",
                children: 'label.jsx-d6214775e28d7de4{-webkit-transition:all 200ms ease-in;-moz-transition:all 200ms ease-in;-o-transition:all 200ms ease-in;transition:all 200ms ease-in;-webkit-transform:translate3d(0,.25rem,0);-moz-transform:translate3d(0,.25rem,0);transform:translate3d(0,.25rem,0)}input.jsx-d6214775e28d7de4{color:#616161;-webkit-transition:all 200ms ease-out;-moz-transition:all 200ms ease-out;-o-transition:all 200ms ease-out;transition:all 200ms ease-out;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input.jsx-d6214775e28d7de4:focus{-webkit-box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);-moz-box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);border-color:#443eff}input.jsx-d6214775e28d7de4:focus+.inputLabel.jsx-d6214775e28d7de4{color:#443eff}.is-filled.jsx-d6214775e28d7de4 input.jsx-d6214775e28d7de4{padding-top:1.25rem}.is-filled.jsx-d6214775e28d7de4 label.jsx-d6214775e28d7de4{opacity:1;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}input[type="number"].jsx-d6214775e28d7de4::-webkit-inner-spin-button,input[type="number"].jsx-d6214775e28d7de4::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;margin:0}input.jsx-d6214775e28d7de4::-webkit-input-placeholder{color:#616161;opacity:1}input.jsx-d6214775e28d7de4:-moz-placeholder{color:#616161;opacity:1}input.jsx-d6214775e28d7de4::-moz-placeholder{color:#616161;opacity:1}input.jsx-d6214775e28d7de4:-ms-input-placeholder{color:#616161;opacity:1}input.jsx-d6214775e28d7de4::-ms-input-placeholder{color:#616161;opacity:1}input.jsx-d6214775e28d7de4::placeholder{color:#616161;opacity:1}@-webkit-keyframes slideUp{0%{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}}@-moz-keyframes slideUp{0%{opacity:0;-moz-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-moz-transform:translateY(-10px);transform:translateY(-10px)}}@-o-keyframes slideUp{0%{opacity:0;-o-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-o-transform:translateY(-10px);transform:translateY(-10px)}}@keyframes slideUp{0%{opacity:0;-webkit-transform:translateY(20px);-moz-transform:translateY(20px);-o-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-webkit-transform:translateY(-10px);-moz-transform:translateY(-10px);-o-transform:translateY(-10px);transform:translateY(-10px)}}.slide-up.jsx-d6214775e28d7de4{-webkit-animation:slideUp 300ms ease-out;-moz-animation:slideUp 300ms ease-out;-o-animation:slideUp 300ms ease-out;animation:slideUp 300ms ease-out}input.jsx-d6214775e28d7de4:disabled{background-color:#e5e5e5;color:#9e9e9e;cursor:not-allowed}'
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextInput);


/***/ }),

/***/ 39494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76166);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89208);
/* harmony import */ var lib_auth_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);













function withAuth(WrappedComponent) {
    var shouldRedirect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return /*#__PURE__*/ function(Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_class, Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_class);
        function _class() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, _class);
            return _super.apply(this, arguments);
        }
        var _proto = _class.prototype;
        _proto.render = function render() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    shouldRedirect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                            name: "robots",
                            content: "noindex, nofollow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, this.props), {
                        auth: this.auth
                    }))
                ]
            });
        };
        _class.getInitialProps = function getInitialProps(ctx) {
            var _this = this;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, callbackPath, auth_page, url, utmSource, utmCampaign, gclid, adName, utmTerm, loginContentType, isIeltsAbTest, token, auth, initialProps, ref1, ref2, pageName, componentProps;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            callbackPath = (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.url;
                            auth_page = null;
                            url = new URL("https://test.com" + callbackPath);
                            auth_page = url.searchParams.get("auth_page");
                            utmSource = url.searchParams.get("utm_source") || undefined;
                            utmCampaign = url.searchParams.get("utm_campaign") || undefined;
                            gclid = url.searchParams.get("gclid") || undefined;
                            adName = url.searchParams.get("ad_name") || undefined;
                            utmTerm = url.searchParams.get("utm_term") || undefined;
                            loginContentType = url.searchParams.get("loginContentType") || undefined;
                            if (loginContentType) {
                                url.searchParams.delete("loginContentType");
                                callbackPath = url.pathname + url.search;
                            }
                            isIeltsAbTest = url.searchParams.get("abTest") || undefined //will be removing this after ab test
                            ;
                            token = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__/* .getTokenCookie */ .r_)(ctx);
                            auth = new lib_auth_token__WEBPACK_IMPORTED_MODULE_3__/* .AuthToken */ .H(token);
                            initialProps = {
                                auth: auth
                            };
                            if (auth && auth.isExpired) {
                                //will be removing isIeltsAbTest after ab test
                                if (shouldRedirect && !isIeltsAbTest) {
                                    ;
                                    pageName = "login";
                                    if (auth_page && auth_page !== "") {
                                        pageName = auth_page;
                                    }
                                    (ref1 = ctx.res) === null || ref1 === void 0 ? void 0 : ref1.writeHead(302, {
                                        Location: _this.buildAuthUrl(pageName, callbackPath, utmSource, utmCampaign, utmTerm, gclid, adName, loginContentType)
                                    });
                                    (ref2 = ctx.res) === null || ref2 === void 0 ? void 0 : ref2.end();
                                }
                            }
                            if (!WrappedComponent.getInitialProps) {
                                _ctx.next = 22;
                                break;
                            }
                            _ctx.next = 20;
                            return WrappedComponent.getInitialProps(ctx);
                        case 20:
                            componentProps = _ctx.sent;
                            return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, componentProps, initialProps));
                        case 22:
                            return _ctx.abrupt("return", initialProps);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        };
        _class.buildAuthUrl = function buildAuthUrl(authPage, callbackPath, utmSource, utmCampaign, utmTerm, gclid, adName, loginContentType) {
            var finalUrl = "/".concat(authPage, "?redirected=true&callbackUrl=").concat(encodeURIComponent(callbackPath || ""));
            if (utmSource) finalUrl += "&utm_source=".concat(utmSource);
            if (utmCampaign) finalUrl += "&utm_campaign=".concat(utmCampaign);
            if (utmTerm) finalUrl += "&utm_term=".concat(utmTerm);
            if (gclid) finalUrl += "&gclid=".concat(gclid);
            if (adName) finalUrl += "&ad_name=".concat(adName);
            if (loginContentType) finalUrl += "&loginContentType=".concat(loginContentType);
            return finalUrl;
        };
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_class, [
            {
                key: "auth",
                get: function get() {
                    var ref;
                    return new lib_auth_token__WEBPACK_IMPORTED_MODULE_3__/* .AuthToken */ .H((ref = this.props.auth) === null || ref === void 0 ? void 0 : ref.token);
                }
            }
        ]);
        return _class;
    }(react__WEBPACK_IMPORTED_MODULE_4__.Component);
};


/***/ }),

/***/ 52291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ user_details_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/decorator/WithAuth.tsx
var WithAuth = __webpack_require__(39494);
// EXTERNAL MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/index.tsx + 2 modules
var IeltsEliteProgressiveForm = __webpack_require__(94599);
// EXTERNAL MODULE: ./uiKit/components/Buttons/index.ts
var Buttons = __webpack_require__(10868);
// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice.ts
var IeltsEliteSlice = __webpack_require__(48472);
// EXTERNAL MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/ieltsEliteFormJson.tsx
var ieltsEliteFormJson = __webpack_require__(27461);
// EXTERNAL MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnActions.ts
var ReferAndEarnActions = __webpack_require__(94063);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./utils/common_utils.ts
var common_utils = __webpack_require__(92177);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Ielts/IeltsOnboardingForms/utils.ts
var utils = __webpack_require__(11403);
// EXTERNAL MODULE: ./components/Inputs/TextField.tsx
var TextField = __webpack_require__(46584);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./DataMapper/IeltsSection/Ielts.tsx
var Ielts = __webpack_require__(92857);
// EXTERNAL MODULE: ./hooks/useDevice.ts
var useDevice = __webpack_require__(84367);
;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/DemoFormFillOffer.tsx




var DemoFormFillOffer = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white/[.8] rounded-lg p-4 md:py-6",
        children: [
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-[#1C1C1C] text-[14px] font-bold mb-3",
                children: "What to expect in session:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:flex gap-x-10",
                children: (isMobile ? Ielts/* demoFormRewardMweb */.We : Ielts/* demoFormReward */._z).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-2 md:p-3 ".concat(index !== 0 ? "border-l border-[#E3E2FF]" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.image,
                                alt: "Ielts rewards",
                                width: 30,
                                height: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pl-2 text-[#424242] text-[12px] md:text-[14px]",
                                children: item.title
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var V2_DemoFormFillOffer = (DemoFormFillOffer);

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/DownloadPdfWidget.tsx


var DownloadPdfWidget = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex py-2 px-4 bg-gradient-to-br from-[#FFF4CB] to-[#F8F8FF] items-center rounded-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts-demo/pdf.svg"),
                alt: "pdf",
                width: 34,
                height: 34
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pl-2 md:pl-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#824710] pr-1 md:pr-2 text-[14px]",
                        children: "Demo Booking Bonus:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#532D0A] font-bold",
                        children: "Free IELTS resource book"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var V2_DownloadPdfWidget = (DownloadPdfWidget);

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/StudentContextText.tsx




var getText = function(currentFormStep) {
    switch(currentFormStep){
        case 1:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Leap’s courses are tailored for IELTS ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Academic and General exam types"
                    ]
                });
            }
        case 2:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Leap provides courses suitable for",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "students and working professionals!"
                    ]
                });
            }
        case 3:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "The best time to start ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "hidden md:block"
                        }),
                        " preparing",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden"
                        }),
                        "for IELTS is today!"
                    ]
                });
            }
        case 4:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#F2A156] font-bold",
                            children: "90%"
                        }),
                        " of Leap’s Students ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "hidden md:block"
                        }),
                        " score",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden"
                        }),
                        " 7.5+ Band in IELTS."
                    ]
                });
            }
        case 5:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-sm md:text-2xl text-[#E8E8E8]",
                    children: [
                        "Your dream life abroad starts ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " with a",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#F2A156]",
                            children: " good IELTS score"
                        })
                    ]
                });
            }
    }
};
var StudentContextText = function(param) {
    var currentFormStep = param.currentFormStep;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center rounded-lg relative h-[70px] md:h-[111px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-white md:text-[20px] px-4 md:px-0 md:pl-6 text-[14px] z-10",
                children: getText(currentFormStep)
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/mweblaptop.png"),
                alt: "laptop",
                layout: "fill",
                objectFit: "cover",
                className: "rounded-lg"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/banner/laptop.jpg"),
                alt: "laptop",
                layout: "fill",
                objectFit: "cover",
                className: "rounded-lg"
            })
        ]
    });
};
/* harmony default export */ var V2_StudentContextText = (StudentContextText);

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/SubmitButton.tsx


var SubmitButton = function(param) {
    var handleSubmit = param.handleSubmit, submitting = param.submitting, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "" : _ctaText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex justify-center mt-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: "bg-primary py-3 rounded text-white flex justify-center w-4/5 md:w-3/5 mx-auto my-4 items-center",
            onClick: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pr-2 md:text-font16 font-bold",
                    children: submitting ? "SAVING..." : ctaText
                }),
                !submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/practice_tab/whitearrow.svg"),
                    className: "scale-125"
                })
            ]
        })
    });
};
/* harmony default export */ var V2_SubmitButton = (SubmitButton);

// EXTERNAL MODULE: ./components/Inputs/CustomInputSelectV5.tsx + 2 modules
var CustomInputSelectV5 = __webpack_require__(18459);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/utils.ts
var TofuOnbordingForms_utils = __webpack_require__(62408);
;// CONCATENATED MODULE: ./componentsLibrary/components/CustomLinearProgress/LinearProgressBar.tsx


var LinearProgressBar = function(param) {
    var width = param.width, color = param.color, bgColor = param.bgColor;
    var widthValue = width ? width.toString() + "%" : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full ".concat(bgColor ? "bg-[".concat(bgColor, "]") : "bg-transparent", " h-2.5"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-2.5 rounded-r-full",
            style: {
                width: widthValue,
                backgroundColor: color ? color : "#7DBC7B"
            }
        })
    });
};
/* harmony default export */ var CustomLinearProgress_LinearProgressBar = (LinearProgressBar);

// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./utils/event_utils.ts
var event_utils = __webpack_require__(59042);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
// EXTERNAL MODULE: ./DataMapper/Common/RegexConstants.ts
var RegexConstants = __webpack_require__(21179);
;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/ieltsEliteFormJsonV2.ts

var ieltsEliteFormRequiredFields = [
    "ieltsExamType",
    "whatCareerStage",
    "whenIelts",
    "name",
    "emailId",
    "phone", 
];
var ieltsEliteJsonV2 = {
    form_id: "Ielts Demo Form",
    form_meta: {
        title: "",
        image: ""
    },
    no_of_steps: 4,
    page_distribution: [
        1,
        1,
        1,
        3
    ],
    is_auto_progressive: true,
    required: ieltsEliteFormRequiredFields,
    fields: [
        {
            question_id: 1,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "ieltsExamType",
            question_text: "What's your IELTS type?",
            options: [
                {
                    label: "IELTS General",
                    value: "GENERAL",
                    color: "#3BAC76",
                    icon: true
                },
                {
                    label: "IELTS Academic",
                    value: "ACADEMIC",
                    color: "#443EFF",
                    icon: true
                },
                {
                    label: "Not Sure",
                    value: "OTHER",
                    color: "#FF9C40",
                    icon: true
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 2,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whatCareerStage",
            question_text: "What are you currently doing?",
            options: [
                {
                    label: "Studying",
                    value: "STUDENT",
                    color: "#3BAC76",
                    icon: true
                },
                {
                    label: "Working",
                    value: "WORKING",
                    color: "#56AADE",
                    icon: true
                },
                {
                    label: "Recently graduated",
                    value: "RECENTLY_GRADUATED",
                    color: "#443EFF",
                    icon: true
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 3,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whenIelts",
            question_text: "When are you giving IELTS?",
            options: [
                {
                    label: "Within 3 months",
                    value: "WITHIN_3_MONTHS",
                    icon: true
                },
                {
                    label: "Within 3 - 6 months",
                    value: "WITHIN_3_6_MONTHS",
                    icon: true
                },
                {
                    label: "After 6 months",
                    value: "AFTER_6_MONTHS",
                    icon: true
                },
                {
                    label: "I've already booked exam",
                    value: "BOOKED_EXAM",
                    icon: true
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 4,
            label: "Name*",
            type: "textInput",
            fieldValue: "name",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: RegexConstants/* nameRegex */.yJ,
                errorMessage: "Enter correct name"
            }
        },
        {
            question_id: 5,
            label: "Email Address*",
            type: "textInput",
            fieldValue: "emailId",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: RegexConstants/* emailRegex */.HN,
                errorMessage: "Please enter correct email"
            }
        },
        {
            question_id: 6,
            label: "Phone Number*",
            type: "textInput",
            fieldValue: "phone",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: RegexConstants/* tenDigitMobileRegex */.Ft,
                errorMessage: "please enter correct number"
            }
        }, 
    ]
};
var getBaselineText = function(currentStep) {
    if (currentStep === 1) return "Get a customized 8-band preparation strategy";
    else if (currentStep === 2) return "Clear your doubts from experienced trainers";
    else if (currentStep === 3) return "Get bonus tips on speaking & writing";
    else if (currentStep === 4) return "Fulfil your dream of succeeding abroad";
    else return "Get a customized 8-band preparation strategy";
};

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/V2/index.tsx





























var IeltsEliteProgressiveFormV2 = function(param) {
    var isLoggedIn = param.isLoggedIn, loggedInNumber = param.loggedInNumber, formJson = param.formJson, prefilledData = param.prefilledData, isMasterclassAlias = param.isMasterclassAlias;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(1), currentFormStep = ref3[0], setCurrentFormStep = ref3[1];
    var ref4 = (0,react.useState)({}), duplicateFormValues = ref4[0], setDuplicateFormValues = ref4[1];
    var ref5 = (0,react.useState)({}), formValues = ref5[0], setFormValues = ref5[1];
    var ref6 = (0,react.useState)(false), isClickingBack = ref6[0], setIsClickingBack = ref6[1];
    var delayForStepChange = (0,react.useRef)(0);
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var stage = (0,es/* useSelector */.v9)(function(state) {
        return state.spotCounselling.stage;
    });
    //Autonext logic
    (0,react.useEffect)(function() {
        var ref;
        if (currentFormStep < (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
            (0,TofuOnbordingForms_utils/* autonextDecision */.hi)(duplicateFormValues, formJson, currentFormStep, setCurrentFormStep, isClickingBack);
        }
        return function() {
            clearTimeout(delayForStepChange.current);
        };
    }, [
        duplicateFormValues
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (currentFormStep < (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
            (0,TofuOnbordingForms_utils/* forceAutonextDecision */.qm)(formJson, currentFormStep, formValues, setCurrentFormStep, isClickingBack);
        }
        (0,segment.trackPageV2)(events_utils.ieltsPageName.DEMO_PROG_FORM, {
            pageNumber: currentFormStep,
            pageContent: (0,utils/* getPageContentForEvent */.LW)(currentFormStep)
        });
        if (currentFormStep > 1 && !isClickingBack) {
            (0,segment.trackIeltsClick)(events_utils.ieltsPageName.DEMO_PROG_FORM, {
                contentName: "Next",
                pageNumber: currentFormStep - 1,
                pageContent: (0,utils/* getPageContentForEvent */.LW)(currentFormStep - 1)
            });
        }
    }, [
        currentFormStep
    ]);
    var handleSaveData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var domainName, utmDetails, newValues, _leadSource, utmObject, formValuesString, redirectURL, utmString, finalString;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        domainName = (0,TofuOnbordingForms_utils/* geturlToRedirect */.sV)();
                        utmDetails = (0,utm_utils/* getUtmData */.M)(null);
                        newValues = cloneDeep_default()(values);
                        newValues.utmSource = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "";
                        newValues.utmCampaign = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "";
                        newValues.utmMedium = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "";
                        newValues.utmTerm = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "";
                        newValues.campaignType = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType) || "";
                        newValues.adId = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "";
                        newValues.gclid = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "";
                        newValues.adName = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "";
                        newValues.formId = utils/* ieltsFormIds.DEMO_PROG_FORM */.$h.DEMO_PROG_FORM;
                        ;
                        newValues.leadSource = (_leadSource = router.query.leadSource) !== null && _leadSource !== void 0 ? _leadSource : utils/* LeadSources.OTHER */.e_.OTHER;
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.name) {
                            newValues.name = (0,TofuOnbordingForms_utils/* nameExtraSpacetriming */.BX)(newValues === null || newValues === void 0 ? void 0 : newValues.name);
                        }
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.howLeapHelp) {
                            newValues.howLeapHelp = newValues.howLeapHelp.join(",");
                        }
                        utmObject = {
                            utm_campaign: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign,
                            utm_source: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource,
                            utm_term: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm,
                            utm_medium: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium,
                            gclid: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid,
                            adName: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName,
                            campaign_type: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType,
                            ad_id: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId
                        };
                        if (loggedInNumber) {
                            newValues.phone = loggedInNumber;
                        }
                        _ctx.next = 20;
                        return (0,segment.trackIeltsFormAsync)("Form Submitted", (0,_object_spread/* default */.Z)({}, newValues, utmObject));
                    case 20:
                        (0,event_utils/* handleFormSubmissionGaEventForm */.dk)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newValues), {
                            stage: stage
                        }), {
                            formType: "redirect",
                            formId: newValues.leadSource === (utils/* LeadSources */.e_ === null || utils/* LeadSources */.e_ === void 0 ? void 0 : utils/* LeadSources.MARKETING_DEMO_MC */.e_.MARKETING_DEMO_MC) ? "Ielts Demo MC Form" : "Ielts Demo Form"
                        });
                        formValuesString = (0,common_utils/* getQueryParamStringFromObject */.BX)(newValues);
                        redirectURL = "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_DEMO_QL_PAGE */.CZ.IELTS_DEMO_QL_PAGE, "?prefilled_phone=").concat(newValues.phone, "&flowType=Elite Demo");
                        utmString = (0,common_utils/* getQueryParamStringFromObject */.BX)(utmObject);
                        finalString = redirectURL + utmString + formValuesString;
                        (0,common_utils/* redirectOutFromIframe */.Zm)(finalString);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSaveData(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var savePersonalInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, saveValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (currentFormStep == (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
                            (0,segment.trackIeltsClick)(events_utils.ieltsPageName.DEMO_PROG_FORM, {
                                contentName: "Send OTP",
                                pageNumber: currentFormStep,
                                pageContent: (0,utils/* getPageContentForEvent */.LW)(currentFormStep)
                            });
                            saveValue = (0,_object_spread/* default */.Z)({}, prefilledData, values);
                            handleSaveData(saveValue);
                        } else {
                            setCurrentFormStep(function(step) {
                                return step + 1;
                            });
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function savePersonalInfo(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCtaText = (0,react.useCallback)(function() {
        if (currentFormStep) {
            var ref;
            if (currentFormStep == (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) if (isMasterclassAlias) return "Select Free Masterclass Slot";
            else return "Select a Free Slot";
            else {
                return "Next";
            }
        }
    }, [
        currentFormStep
    ]);
    var goBackButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-fit text-gray-1741 items-center pt-4 md:pl-0 pl-2 cursor-pointer my-4 hidden md:flex",
        onClick: function() {
            setCurrentFormStep(function(step) {
                return step - 1;
            });
            setDuplicateFormValues({});
            setIsClickingBack(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/left_triangle_arrow.svg"),
                alt: "",
                width: "30px",
                height: "30px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-font16 pl-2 text-[#1B1D6A] opacity-80 hidden md:block",
                children: "Go Back"
            })
        ]
    });
    var backImageMob = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/left_triangle_arrow.svg"),
        alt: "",
        width: "25px",
        height: "25px",
        onClick: function() {
            setCurrentFormStep(function(step) {
                return step - 1;
            });
            setDuplicateFormValues({});
            setIsClickingBack(true);
        },
        className: "md:hidden absolute left-0 top-0 z-20"
    });
    var RenderFields = function(param) {
        var component_type = param.component_type, question_text = param.question_text, options = param.options, validation = param.validation, fieldValue = param.fieldValue, label = param.label, default_visibility = param.default_visibility, visibility_dependency = param.visibility_dependency, values = param.values, numGridColumns = param.numGridColumns, question_id = param.question_id, _isMultiSelect = param.isMultiSelect, isMultiSelect = _isMultiSelect === void 0 ? false : _isMultiSelect, _maxSelect = param.maxSelect, maxSelect = _maxSelect === void 0 ? 1 : _maxSelect, handleSubmit = param.handleSubmit, submitting = param.submitting;
        var ref;
        var getButton = function() {
            if (fieldValue === "emailId" && isLoggedIn || fieldValue === "phone") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(V2_SubmitButton, {
                    ctaText: getCtaText(),
                    handleSubmit: handleSubmit,
                    submitting: submitting
                });
            }
        };
        var isThisFieldVisible = true;
        for(var i = 0; i < (visibility_dependency === null || visibility_dependency === void 0 ? void 0 : (ref = visibility_dependency.dependencies) === null || ref === void 0 ? void 0 : ref.length); i++){
            var ref1, ref2, ref3;
            if ((ref1 = visibility_dependency === null || visibility_dependency === void 0 ? void 0 : visibility_dependency.dependencies[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.includes(values[(0,TofuOnbordingForms_utils/* getDependentQuestionFieldName */.KB)(formJson, (ref3 = visibility_dependency === null || visibility_dependency === void 0 ? void 0 : visibility_dependency.dependencies[i]) === null || ref3 === void 0 ? void 0 : ref3.question_id)])) {
                continue;
            } else {
                isThisFieldVisible = false;
                break;
            }
        }
        if (isThisFieldVisible || default_visibility) switch(component_type){
            case "single_select_tile":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " text-black md:text-xl font-bold text-center relative ".concat(question_id === 1 ? "md:pt-[70px]" : null),
                                children: [
                                    currentFormStep > 1 && backImageMob,
                                    question_text
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:py-2 px-1 py-2 ",
                                onMouseDown: function(event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: fieldValue,
                                    label: label,
                                    component: CustomInputSelectV5/* default */.Z,
                                    options: options,
                                    isMultiSelect: isMultiSelect,
                                    maxSelect: maxSelect,
                                    numGridColumns: numGridColumns !== null && numGridColumns !== void 0 ? numGridColumns : null,
                                    validate: function() {},
                                    onClick: function(e) {
                                        setIsClickingBack(false);
                                        if (!isMultiSelect && (formJson === null || formJson === void 0 ? void 0 : formJson.is_auto_progressive)) {
                                            delayForStepChange.current = window.setTimeout(function() {
                                                var ref;
                                                setDuplicateFormValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, duplicateFormValues), (0,_define_property/* default */.Z)({}, fieldValue, e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value)));
                                            }, 200);
                                        }
                                    },
                                    checkBoxVersion: 8,
                                    ieltsQe: true
                                })
                            }),
                            values[fieldValue] && /*#__PURE__*/ (0,jsx_runtime.jsx)(V2_SubmitButton, {
                                ctaText: getCtaText(),
                                handleSubmit: handleSubmit,
                                submitting: submitting
                            })
                        ]
                    });
                }
            case "numberInput":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-black md:text-xl font-bold",
                                children: question_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:px-7 md:py-2 px-4 py-2 w-full md:w-4/5 md:mx-auto shadow-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: fieldValue,
                                    component: TextField/* default */.Z,
                                    placeholder: label,
                                    label: "label",
                                    type: "number",
                                    validate: function(v) {
                                        if ((formJson === null || formJson === void 0 ? void 0 : formJson.required.includes(fieldValue)) && !v) return "This is a mandatory field";
                                        if (v && validation.pattern) {
                                            var regex = new RegExp(validation === null || validation === void 0 ? void 0 : validation.pattern);
                                            if (!regex.test(v)) return validation.errorMessage;
                                        }
                                    }
                                })
                            })
                        ]
                    });
                }
            case "textInput":
                {
                    if (fieldValue === "phone" && !isLoggedIn || fieldValue !== "phone") return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-black md:text-xl font-bold",
                                        children: question_text
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " md:py-2 py-2 w-full ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                name: fieldValue,
                                                component: TextField/* default */.Z,
                                                placeholder: label,
                                                label: label,
                                                type: "text",
                                                validate: function(v) {
                                                    if ((formJson === null || formJson === void 0 ? void 0 : formJson.required.includes(fieldValue)) && !v) return "This is a mandatory field";
                                                    if (v && !v.trim()) return "Please enter correct answer";
                                                    if (v && validation.pattern) {
                                                        var regex = new RegExp(validation === null || validation === void 0 ? void 0 : validation.pattern);
                                                        if (!regex.test(v)) return validation.errorMessage;
                                                    }
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            getButton()
                        ]
                    });
                }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col justify-between !min-h-[100vh] h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLinearProgress_LinearProgressBar, {
                        width: Math.round(currentFormStep / (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length) * 100),
                        color: "#5CB9B6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 md:px-0 md:max-w-[900px] mx-auto rounded-10 relative z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:px-10 mt-8 md:mt-6",
                            children: [
                                currentFormStep < 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2_StudentContextText, {
                                        currentFormStep: 5
                                    })
                                }),
                                currentFormStep >= 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative h-24 flex justify-center items-center",
                                    children: [
                                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                backImageMob,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/congrats_confetti_text.svg"),
                                                    layout: "fill"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "z-10 flex flex-col items-center md:gap-5 gap-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-bold text-[#0A0926] text-[20px] md:text-[24px]",
                                                    children: [
                                                        "Crack",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "bg-gradient-to-r from-[#635EFF] via-[#663CFF] to-[#5200FF] text-white px-3 rounded-3 inline-block skew-x-[-10deg]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "inline-block skew-x-[10deg]",
                                                                children: "IELTS"
                                                            })
                                                        }),
                                                        " ",
                                                        "in 1st attempt"
                                                    ]
                                                }),
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "border border-[#E3E3FD] w-[100%] my-5"
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[#0A0926] opacity-70 text-base font-semibold",
                                                    children: isMasterclassAlias ? "Enter your details to confirm your masterclass" : "Enter your details to confirm your demo class"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                currentFormStep > 1 && goBackButton,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col justify-between md:max-w-[600px] m-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                            onSubmit: savePersonalInfo,
                                            initialValues: prefilledData,
                                            children: function(param) {
                                                var handleSubmit = param.handleSubmit, values = param.values, submitting = param.submitting;
                                                setFormValues(values);
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                        onSubmit: handleSubmit,
                                                        noValidate: true,
                                                        className: "md:min-h-[300px] mt-8",
                                                        children: formJson === null || formJson === void 0 ? void 0 : formJson.fields.slice((0,TofuOnbordingForms_utils/* indexCal */.e2)(formJson, currentFormStep)[0], (0,TofuOnbordingForms_utils/* indexCal */.e2)(formJson, currentFormStep)[1]).map(function(field) {
                                                            var type = field.type, options = field.options, question_text = field.question_text, fieldValue = field.fieldValue, label = field.label, validation = field.validation, default_visibility = field.default_visibility, visibility_dependency = field.visibility_dependency, numGridColumns = field.numGridColumns, question_id = field.question_id, isMultiSelect = field.isMultiSelect, maxSelect = field.maxSelect;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: RenderFields({
                                                                    component_type: type,
                                                                    question_text: question_text,
                                                                    options: options,
                                                                    validation: validation,
                                                                    fieldValue: fieldValue,
                                                                    label: label,
                                                                    default_visibility: default_visibility,
                                                                    visibility_dependency: visibility_dependency,
                                                                    values: values,
                                                                    numGridColumns: numGridColumns,
                                                                    question_id: question_id,
                                                                    isMultiSelect: isMultiSelect,
                                                                    maxSelect: maxSelect,
                                                                    handleSubmit: handleSubmit,
                                                                    submitting: submitting
                                                                })
                                                            });
                                                        })
                                                    })
                                                });
                                            }
                                        })
                                    })
                                }),
                                currentFormStep === (formJson === null || formJson === void 0 ? void 0 : (ref1 = formJson.page_distribution) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-4 md:px-0 flex justify-center md:items-center flex-col gap-4 pb-8 py-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2_DownloadPdfWidget, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            currentFormStep === (formJson === null || formJson === void 0 ? void 0 : (ref2 = formJson.page_distribution) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 md:px-0 flex justify-center md:items-center flex-col gap-4 pb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2_DemoFormFillOffer, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "bg-[#F8F8FF] rounded-6 flex gap-x-2 py-3 px-4 md:px-12 items-center justify-center mt-4 w-fit mx-auto mb-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/yellow_bulb.svg"),
                        alt: "bulb_icon",
                        width: "20px",
                        height: "20px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[12px] md:text-[15px] text-[#424242] inline-block min-w-fit",
                        children: getBaselineText(currentFormStep)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: isMobile ? "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts_qe_bg_mob.svg") : "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/ielts_qe_bg_web.png"),
                layout: "fill",
                objectFit: "fill",
                className: "z-[-2]"
            })
        ]
    });
};
/* harmony default export */ var V2 = (IeltsEliteProgressiveFormV2);

// EXTERNAL MODULE: ./hooks/ielts/useDemoAlias.ts
var useDemoAlias = __webpack_require__(36728);
// EXTERNAL MODULE: ./components/common/LineBreak.tsx
var LineBreak = __webpack_require__(81964);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/ielts-preparation-online/ielts-elite-demo/user-details-form.tsx
























var checkFormVersionIsTwo = function(form_version) {
    return form_version === "2";
};
var UserDetailsFormPage = function() {
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).auth;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), userState = ref[0], setUserState = ref[1];
    var ref1 = (0,react.useState)(false), showRedirectCta = ref1[0], setShowRedirectCta = ref1[1];
    var ref2 = (0,react.useState)({}), prefilledData = ref2[0], setPrefilledData = ref2[1];
    var ref3 = (0,react.useState)(null), demoBookFormJson = ref3[0], setDemoBookFormJson = ref3[1];
    var userInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.referAndEarn;
    }).userInfo;
    var _query = router.query, form_version = _query.form_version, isDisqualifiedUser = _query.isDisqualifiedUser;
    var isDisqualifiedUserFlow = isDisqualifiedUser === "true";
    var isMasterclassAlias = (0,useDemoAlias/* default */.Z)().isMasterclassAlias;
    (0,react.useEffect)(function() {
        if (checkFormVersionIsTwo(form_version)) {
            (0,segment.trackIeltsEvent)("Optimise selection", {
                optimizeSelection: "Base"
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        if (auth === null || auth === void 0 ? void 0 : auth.isValid) {
            dispatch(ReferAndEarnActions/* referAndEarnActions.fetchUserInfo */.F.fetchUserInfo());
            if (!isDisqualifiedUserFlow) {
                dispatch((0,IeltsEliteSlice/* updatePostGetStageAction */.Dr)(function(studentStage) {
                    setUserState(studentStage);
                    if (studentStage === IeltsEliteSlice/* IeltsStageType.IELTS_DEMO_BOOKED */.QW.IELTS_DEMO_BOOKED || studentStage === IeltsEliteSlice/* IeltsStageType.IELTS_DEMO_ATTENDED */.QW.IELTS_DEMO_ATTENDED) {
                        dispatch((0,IeltsEliteSlice/* updatePostGetStudentEligibility */.c0)(function(eligibilityData) {
                            if ((eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.slotType) && (eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.slotType) >= 1 && (eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.slotType) <= 3) {
                                (0,segment.trackPageV2)("Go To Dashboard", {
                                    formId: (0,utils/* getFormId */.cY)(!!isDisqualifiedUser, isMasterclassAlias),
                                    demoStage: studentStage
                                });
                                setShowRedirectCta(true);
                            } else {
                                router.push(page_routes/* navRoutes.IELTS_DEMO_QL_PAGE */.CZ.IELTS_DEMO_QL_PAGE);
                            }
                        }));
                        dispatch((0,IeltsEliteSlice/* fetchGetStudentEligibility */.eE)());
                    } else if (studentStage === IeltsEliteSlice/* IeltsStageType.LS_USER_ACQUIRED */.QW.LS_USER_ACQUIRED && !isDisqualifiedUserFlow) {
                        router.push(page_routes/* navRoutes.IELTS_DEMO_QL_PAGE */.CZ.IELTS_DEMO_QL_PAGE);
                    }
                }));
                dispatch((0,IeltsEliteSlice/* fetchGetIeltsStage */.Wv)());
            }
        }
    }, [
        auth,
        isDisqualifiedUserFlow
    ]);
    (0,react.useEffect)(function() {
        if (!(auth === null || auth === void 0 ? void 0 : auth.isValid) || userInfo.phone) {
            getUserForm();
        }
    }, [
        userInfo,
        auth
    ]);
    var getDemoFlowJson = function() {
        return isMasterclassAlias ? ieltsEliteFormJson/* ieltsDemoMasterclassJson */.bX : ieltsEliteFormJson/* ieltsEliteJson */.xb;
    };
    var getUserForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var prefilledData, filterFields;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        prefilledData = {};
                        if (!(auth === null || auth === void 0 ? void 0 : auth.isValid)) {
                            _ctx.next = 9;
                            break;
                        }
                        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) prefilledData["phone"] = userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone;
                        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) prefilledData["emailId"] = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email;
                        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) prefilledData["name"] = userInfo === null || userInfo === void 0 ? void 0 : userInfo.name;
                        if (!((prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.phone) && (prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.emailId) && (prefilledData === null || prefilledData === void 0 ? void 0 : prefilledData.name))) {
                            _ctx.next = 9;
                            break;
                        }
                        filterFields = [
                            "emailId",
                            "name",
                            "phone"
                        ];
                        if (checkFormVersionIsTwo(form_version)) {
                            setDemoBookFormJson((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ieltsEliteJsonV2), {
                                no_of_steps: 3,
                                page_distribution: [
                                    1,
                                    1,
                                    1
                                ],
                                fields: ieltsEliteJsonV2.fields.filter(function(field) {
                                    return !filterFields.includes(field.fieldValue);
                                })
                            }));
                        } else {
                            setDemoBookFormJson((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getDemoFlowJson()), {
                                page_distribution: [
                                    4
                                ],
                                is_auto_progressive: false,
                                fields: getDemoFlowJson().fields.filter(function(field) {
                                    return !filterFields.includes(field.fieldValue);
                                })
                            }));
                        }
                        return _ctx.abrupt("return", setPrefilledData(prefilledData));
                    case 9:
                        if (checkFormVersionIsTwo(form_version)) {
                            setDemoBookFormJson(ieltsEliteJsonV2);
                        } else {
                            setDemoBookFormJson(getDemoFlowJson());
                        }
                        return _ctx.abrupt("return", setPrefilledData(prefilledData));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUserForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var trackGoBackDashboardEvent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,segment.trackEventAsync)("Click", {
                            pageName: isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_1 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_1,
                            contentName: "Go To Dashboard",
                            contentFormat: "Button",
                            widgetFormat: "Button",
                            formId: (0,utils/* getFormId */.cY)(!!isDisqualifiedUser, isMasterclassAlias),
                            demoStage: userState
                        });
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("event err", _ctx.t0);
                    case 8:
                        _ctx.prev = 8;
                        (0,common_utils/* redirectOutFromIframe */.Zm)(page_routes/* navRoutes.IELTS_STUDENT_DASHBOARD */.CZ.IELTS_STUDENT_DASHBOARD);
                        return _ctx.finish(8);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5,
                    8,
                    11
                ]
            ]);
        }));
        return function trackGoBackDashboardEvent() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex, nofollow"
                })
            }),
            showRedirectCta ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center items-center md:items-stretch h-[100vh] flex-col md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                        size: "large",
                        onClick: function() {
                            trackGoBackDashboardEvent();
                        },
                        customCss: "self-center",
                        children: "Go To Dashboard"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/lead-capture/background-illustration.svg"),
                        className: "bottom-0 hidden md:block -z-1 md:absolute"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/lead-capture/background-illustration-mobile.svg"),
                        className: "bottom-0 md:hidden w-full -z-1"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: checkFormVersionIsTwo(form_version) && demoBookFormJson ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V2, {
                    formJson: demoBookFormJson,
                    isLoggedIn: auth === null || auth === void 0 ? void 0 : auth.isValid,
                    loggedInNumber: userInfo.phone,
                    prefilledData: prefilledData,
                    isMasterclassAlias: isMasterclassAlias
                }) : demoBookFormJson && /*#__PURE__*/ (0,jsx_runtime.jsx)(IeltsEliteProgressiveForm/* default */.Z, {
                    formJson: demoBookFormJson,
                    isLoggedIn: auth === null || auth === void 0 ? void 0 : auth.isValid,
                    loggedInNumber: userInfo.phone,
                    prefilledData: prefilledData,
                    formHeading: isDisqualifiedUserFlow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "font-bold text-[#0A0926] text-center pt-4 text-[20px]",
                        children: [
                            "You’re almost there to book your",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineBreak/* default */.Z, {
                                device: "mobile"
                            }),
                            " IELTS demo session"
                        ]
                    }) : null
                })
            })
        ]
    });
};
/* harmony default export */ var user_details_form = ((0,WithAuth/* default */.Z)(UserDetailsFormPage, false));


/***/ }),

/***/ 10868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _src__WEBPACK_IMPORTED_MODULE_0__.O; },
/* harmony export */   "z": function() { return /* reexport safe */ _src__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _src__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76279);



/***/ }),

/***/ 76279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; },
  "O": function() { return /* reexport */ GradientButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./uiKit/components/Buttons/src/Button/style.module.scss
var style_module = __webpack_require__(54643);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./uiKit/components/Buttons/src/Button/index.tsx








/**
 * Primary UI component for user interaction
 */ var Button = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "medium" : _size, children = _param.children, onClick = _param.onClick, isDisable = _param.isDisable, isFullWidth = _param.isFullWidth, customCss = _param.customCss, _delay = _param.delay, delay = _delay === void 0 ? 30 : _delay, disableCss = _param.disableCss, responsiveButton = _param.responsiveButton, loadingAnimation = _param.loadingAnimation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "size",
        "children",
        "onClick",
        "isDisable",
        "isFullWidth",
        "customCss",
        "delay",
        "disableCss",
        "responsiveButton",
        "loadingAnimation"
    ]);
    var ref = (0,react.useState)(!!loadingAnimation), showLoader = ref[0], setShowLoader = ref[1];
    var buttonTypeCss = function(buttonType) {
        if (isDisable) {
            return disableCss ? disableCss : "text-gray-400 bg-lightgray-100 border-lightgray-100";
        }
        switch(buttonType){
            case "primary":
                return "text-white bg-primary";
            case "secondary":
                return "text-primary bg-white border-primary";
            case "success":
                return "text-white bg-green-400 border-green-400";
            case "danger":
                return "bg-red-400 text-white border-red-400 border";
            case "white":
                return "text-blue-100 bg-white border-white";
            case "darkBlue":
                return "text-white bg-blue-100 border-blue-100";
            case "warning":
                return "bg-yellow-850 text-blue-100 border-yellow-850";
            case "gradient_orange":
                return "bg-yellow-to-orange cursor-pointer text-white border-white";
            case "blue-text":
                return "text-primary bg-lightgray-175 border-white";
            case "white_bg_primary_text":
                return "text-primary bg-white border-lightgray-175";
            case "bgNone":
                return "bg-none border-lightgray-175";
            case "gradient_blue":
                return "bg-gradient-to-r from-[#635EFF] to-[#5200FF] text-white";
            case "gradient_blue_light":
                return "bg-[linear-gradient(180deg,#6564FB_0%,#4946EF_100%)]";
            case "white_gradient":
                return "bg-[linear-gradient(81deg,#F3F3FF_14.27%,#F2EBFF_85.65%)]";
            case "secondary-2":
                return "text-[#443eff] border-[#443eff]";
            default:
                return "";
        }
    };
    (0,react.useEffect)(function() {
        var timer = loadingAnimation ? setTimeout(function() {
            loadingAnimation.onComplete();
            setShowLoader(false);
        }, loadingAnimation.duration * 1000) : null;
        return function() {
            timer && clearTimeout(timer);
        };
    }, []);
    var getResponsiveStyles = function(variants) {
        var stylesForSmallMediumLarge = {
            small: "text-sm px-2 py-1",
            medium: "text-base px-4 py-2",
            large: "text-xl px-6 py-2"
        };
        var cssStyles = stylesForSmallMediumLarge[variants.desktopVariant].split(" ").map(function(item) {
            return "md:".concat(item);
        }).join(" ");
        cssStyles = "".concat(cssStyles, " ").concat(stylesForSmallMediumLarge[variants.mobileVariant]);
        return cssStyles;
    };
    var buttonSizeCss = function(buttonSize) {
        if (responsiveButton) {
            return getResponsiveStyles(responsiveButton);
        }
        switch(buttonSize){
            case "small":
                return "text-sm px-2 py-1";
            case "medium":
                return "text-base md:px-4 py-2";
            case "large":
                return "text-xl px-6 py-2";
            default:
                return "";
        }
    };
    // added debouncing to avoid button thrashing
    var onClickHandler = debounce_default()(function() {
        if (!isDisable && onClick) {
            onClick();
        }
    }, delay);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: [
            "font-bold rounded border relative",
            buttonTypeCss(variant),
            buttonSizeCss(size),
            isDisable ? "cursor-not-allowed" : "cursor-pointer",
            isFullWidth && "w-full",
            customCss ? customCss : "", 
        ].join(" "),
        onClick: onClickHandler
    }, props), {
        children: [
            children,
            loadingAnimation && showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "h-full absolute top-0 left-0 rounded-l-xl",
                    (style_module_default()).buttonAnimation, 
                ].join(" "),
                style: {
                    animation: "reduceWidth ".concat(loadingAnimation.duration, "s ease-in-out")
                }
            })
        ]
    }));
};

// EXTERNAL MODULE: ./uiKit/components/Buttons/src/GradientButton/GardientButtonStyles.module.scss
var GardientButtonStyles_module = __webpack_require__(20337);
var GardientButtonStyles_module_default = /*#__PURE__*/__webpack_require__.n(GardientButtonStyles_module);
;// CONCATENATED MODULE: ./uiKit/components/Buttons/src/GradientButton/index.tsx







var GradientButton = function(_param) {
    var isDisable = _param.isDisable, isFullWidth = _param.isFullWidth, onClick = _param.onClick, children = _param.children, customCss = _param.customCss, delay = _param.delay, _size = _param.size, size = _size === void 0 ? "md" : _size, _variant = _param.variant, variant = _variant === void 0 ? "orange" : _variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDisable",
        "isFullWidth",
        "onClick",
        "children",
        "customCss",
        "delay",
        "size",
        "variant"
    ]);
    var onClickHandler = debounce_default()(function() {
        if (!isDisable && onClick) {
            onClick();
        }
    }, delay);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: [
            (GardientButtonStyles_module_default()).button,
            isDisable ? (GardientButtonStyles_module_default())["disable-yes"] : (GardientButtonStyles_module_default())["disable-no"],
            isFullWidth && "w-full",
            customCss ? customCss : "",
            (GardientButtonStyles_module_default())["variant-" + variant],
            (GardientButtonStyles_module_default())["size-" + size], 
        ].join(" "),
        onClick: onClickHandler
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./uiKit/components/Buttons/src/index.ts




/***/ }),

/***/ 73243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bundleContainer":"PaymentBundle_bundleContainer___pwmY","blue-gradient-text":"PaymentBundle_blue-gradient-text__sr4tN","payment-font-family":"PaymentBundle_payment-font-family__yBhw6","poppins-font-family":"PaymentBundle_poppins-font-family__FSxjN","figtree-font-family":"PaymentBundle_figtree-font-family__tYGLv"};

/***/ }),

/***/ 97506:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapperLeadCapture":"LeadCaptureLayout_wrapperLeadCapture___FIGO","wrapperLeadCaptureProfile":"LeadCaptureLayout_wrapperLeadCaptureProfile__RsmWH","v3BackgroundColor":"LeadCaptureLayout_v3BackgroundColor__WUDne","anlysisBackColor":"LeadCaptureLayout_anlysisBackColor__GCkje","applyColorOnBody":"LeadCaptureLayout_applyColorOnBody__AmrAn","fieldsContainer":"LeadCaptureLayout_fieldsContainer__2ZKZG","courseBadge":"LeadCaptureLayout_courseBadge__nNwNE","v8Wrapper":"LeadCaptureLayout_v8Wrapper__zdHVZ","v8ContainerMover":"LeadCaptureLayout_v8ContainerMover__e_X5s","knowMore":"LeadCaptureLayout_knowMore__9vs_T","thinkingPopup":"LeadCaptureLayout_thinkingPopup__vhOGg","arrowBox":"LeadCaptureLayout_arrowBox__Z4_8p","infoCard":"LeadCaptureLayout_infoCard__rXaB9","knowMoreContent":"LeadCaptureLayout_knowMoreContent__Td4SS","counsellingBanner":"LeadCaptureLayout_counsellingBanner__vkgiP","button":"LeadCaptureLayout_button__Swcrr","newWrapper":"LeadCaptureLayout_newWrapper__OXEME","lastCompo":"LeadCaptureLayout_lastCompo__12kqW","newWrapperVariant1":"LeadCaptureLayout_newWrapperVariant1__c4eC_","bac":"LeadCaptureLayout_bac__zzFKk","howLeapHelp":"LeadCaptureLayout_howLeapHelp___JaXu","emoji":"LeadCaptureLayout_emoji__2q2Lo","optionStyle":"LeadCaptureLayout_optionStyle__YSF9D","selectedOptionStyle":"LeadCaptureLayout_selectedOptionStyle__PP8Jx","buttonWithArrow":"LeadCaptureLayout_buttonWithArrow__pmSZ8"};

/***/ }),

/***/ 54643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonAnimation":"style_buttonAnimation___JjpF"};

/***/ }),

/***/ 20337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"size-sm":"GardientButtonStyles_size-sm__B_H7c","size-md":"GardientButtonStyles_size-md__4xHoh","size-lg":"GardientButtonStyles_size-lg__Pf42a","size-xl":"GardientButtonStyles_size-xl__BB7xc","size-custom":"GardientButtonStyles_size-custom__tn_Hk","variant-orange":"GardientButtonStyles_variant-orange__NjrHE","variant-gray":"GardientButtonStyles_variant-gray__L4xTx","button":"GardientButtonStyles_button__KRZg7","disable-yes":"GardientButtonStyles_disable-yes__LAs9G","disable-no":"GardientButtonStyles_disable-no__luBuL"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4889,6472,7205,7461,8314,4599,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(83047); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);